export enum TrackingEvent {
  ResetSort = `[Sorting Menu] Reset`,
  ToggledSortingMode = `[Sorting Menu] Changed Sorting Mode`,
  UpdatedColumn = `[Sorting Menu] Updated Column Sorting`,
  UpdatedFlattenedSorting = `[Sorting Menu] Updated Flattened Sorting`,
}
